import { PropsWithChildren } from "react"
import { selectUserType } from "../login/loginSelectors"
import { useAppSelector } from "../store/storeHooks"
import { UserType } from "../login/loginTypes"

type MatchActualUserTypeProps = Readonly<
    PropsWithChildren<{
        userTypes: UserType[]
    }>
>

export function MatchActualUserType({ userTypes, children }: MatchActualUserTypeProps) {
    const actualUserType = useAppSelector(selectUserType)

    if (actualUserType && userTypes.includes(actualUserType)) {
        return <>{children}</>
    }

    return null
}
